<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>내 정보</h1>
            <!-- <span class="edit">
                <a href="/mypageEdit.html">수정</a>
            </span> -->
        </div>
    </header>
    <Footer />
    <main id="sub" class="mypage">
        <div class="mypage-wrap mypage-detail-wrap">
            <ul class="mypage-detail-lists">
                <li class="mypage-detail-list">
                    <strong class="mypage-detail-tit">기본정보</strong>
                    <ul class="mypage-detail-inr-lists">
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>이름</dt>
                                <dd>{{this.name}}</dd>
                            </dl>
                        </li>
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>이메일</dt>
                                <dd>{{this.email}}</dd>
                            </dl>
                        </li>
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>휴대폰 번호</dt>
                                <dd>{{this.phone_no}}</dd>
                            </dl>
                        </li>
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>포인트</dt>
                                <dd>{{numberComma(this.point.toString())}}잎</dd>
                            </dl>
                        </li>
                    </ul>
                </li>
                <li class="mypage-detail-list">
                    <strong class="mypage-detail-wrap">입주정보</strong>
                    <ul class="mypage-detail-inr-lists">
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>거주지</dt>
                                <dd>[{{this.roomTypeText}}] {{COMPANY_INFORMATION.BUILDING}} </dd>
                            </dl>
                        </li>
                        <li class="mypage-detail-inr-list">
                            <dl>
                                <dt>입주 호수</dt>
                                <dd>
                                    <span class="font-prompt">{{room_number}}</span>
                                </dd>
                            </dl>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <ul class="mypage-bottom-btns">
            <li class="mypage-bottom-btn after-arrow" @click="goToResetPassword()" v-if="!isGuest">
                <a>
                    비밀번호 재설정
                </a>
            </li>
            <li class="mypage-bottom-btn after-arrow" @click="logout()">
                <a>
                    로그아웃
                </a>
            </li>
            <li class="mypage-bottom-btn after-arrow" @click="goToUserLeave()" v-if="!isGuest">
                <a>
                    회원탈퇴
                </a>
            </li>
        </ul>
    </main>
</div>
</template>

<script>
import {
    COMPANY_INFORMATION,
    GUEST_INFO
} from "@/config/const.js";

import Footer from "@/components/common/Footer";

export default {
    components: {
        Footer
    },
    data() {
        return {
            user_email: this.$store.state.userInfo.email,
            COMPANY_INFORMATION: COMPANY_INFORMATION,

            user_pk: this.$store.state.userInfo.pk,
            name: this.$store.state.userInfo.name,
            email: "",
            phone_no: "",
            point: 0,

            room_type: "",
            room_number: "",
        };
    },
    computed: {
        isGuest() {
            return this.user_email === GUEST_INFO.EMAIL;
        },
        roomTypeText() {
            return this.room_type === "kosiwon" ? "고시원" : "쉐어하우스";
        }
    },
    mounted() {
        this.axios.get(`/user/${this.user_pk}?with_room=true`).then(res => {
            this.email = res.data.result.user.email;
            this.phone_no = res.data.result.user.phone_no;
            this.point = res.data.result.user.point;

            this.room_type = res.data.result.room.room_type;
            this.room_number = res.data.result.room.room_number;
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        numberComma(value) {
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goToResetPassword() {
            this.$router.push({
                path: "/user/find/pw",
                query: {
                    email: this.email,
                    phone_no: this.phone_no
                }
            });
        },
        logout() {
            if (confirm("로그아웃하시겠습니까?")) {
                this.axios.post("/logout", {
                    pk: this.user_pk
                }).then(() => {
                    this.$store.commit("DEL_TOKEN");
                    this.$store.commit("DEL_USERINFO");

                    this.$router.push({
                        path: "/"
                    });
                }).catch(err => {
                    console.log(err);
                });
            }
        },
        goToUserLeave() {
            this.$router.push({
                path: "/user/leave"
            });
        }
    }
};
</script>
